// Report visibility is separate from permission to start work at a site.
// Callers supply only sites already returned by the server for this user.
export const reportingSiteMap = sites => {
  const counts = new Map();
  sites.forEach(site => counts.set(site.siteName, (counts.get(site.siteName) ?? 0) + 1));
  const usedLabels = new Set(['All Sites']);
  return Object.fromEntries(
    sites.map(site => {
      let label =
        counts.get(site.siteName) > 1 ? `${site.siteName} (site ${site.siteId})` : site.siteName;
      while (usedLabels.has(label)) label = `${label} (site ${site.siteId})`;
      usedLabels.add(label);
      return [
        label,
        {
          siteId: site.siteId,
          active: site.active,
          address: `${site.addressStreet}, ${site.addressCity} ${site.addressZip}`,
        },
      ];
    }),
  );
};

export const reportingSites = (sites, status) =>
  Object.fromEntries(
    Object.entries(sites).filter(([, site]) =>
      status === 'all' ? true : site.active === (status === 'active'),
    ),
  );

export const reportingGroups = (groups, sites) => {
  const siteIds = new Set(Object.values(sites).map(site => site.siteId));
  return groups.filter(group => siteIds.has(group.siteId));
};

export const initialReportingSite = (sites, groups, requestedName, viewAll = 'All Sites') => {
  const names = Object.keys(sites);
  if (requestedName && Object.prototype.hasOwnProperty.call(sites, requestedName)) {
    return requestedName;
  }
  if (names.length === 1) return names[0];
  if (groups.length === 0) return names[0] ?? viewAll;
  if (!requestedName && groups.length === 1) {
    return names.find(name => sites[name].siteId === groups[0].siteId) ?? viewAll;
  }
  return viewAll;
};
